import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { AppDomain, FeatureFlagUseCase, PermissionsDomains, PermissionsResources, ResourceBehavior, } from '@ibk/shared-types';
import { useInstructionsPermissioning, useRequiresAuthorization } from '../hooks';
export const hasAccountPjParams = {
    domain: PermissionsDomains.ACCOUNT,
    resources: [PermissionsResources.ACCOUNT_VIEW_BALANCE, PermissionsResources.ACCOUNT_VIEW_STATEMENTS],
};
export const hasDigitalAccountingParams = {
    domain: PermissionsDomains.DIGITAL_ACCOUNTING,
    resources: [PermissionsResources.DIGITAL_ACCOUNTING_VIEW_CONSENTS],
};
export const hasBillingParams = {
    domain: PermissionsDomains.BILLING,
    resources: [
        PermissionsResources.BILLING_CANCEL_BILLING,
        PermissionsResources.BILLING_CREATE_BILLING,
        PermissionsResources.BILLING_VIEW_BILLING,
        PermissionsResources.BILLING_VIEW_TARIFFS,
    ],
};
export const hasBenefitParams = {
    domain: PermissionsDomains.BENEFITS,
    resources: [
        PermissionsResources.BENEFITS_CREATE_RECHARGE,
        PermissionsResources.BENEFITS_CREATE_VOUCHER_CONTRACT,
        PermissionsResources.BENEFITS_VIEW_BENEFICIARIES,
        PermissionsResources.BENEFITS_VIEW_RECHARGES,
    ],
};
export const hasProgramaFidelidadeParams = {
    domain: PermissionsDomains.DOMINIO_RECOMPENSAS,
    resources: [PermissionsResources.FIDELITY_PROGRAM_VIEW_PROGRAM],
};
export const hasClientPortalParams = {
    domain: PermissionsDomains.CLIENT_PORTAL,
    resources: [PermissionsResources.CLIENT_PORTAL_VIEW_PORTAL],
};
export const hasNfseParams = {
    domain: PermissionsDomains.NFSE,
    resources: [
        PermissionsResources.NFSE_VIEW_INVOICES,
        PermissionsResources.NFSE_ISSUE_INVOICES,
        PermissionsResources.NFSE_CANCEL_INVOICES,
        PermissionsResources.NFSE_MANAGE_SETTINGS,
    ],
};
export const useGetHomePermissions = () => {
    const appDomain = useAppSelector(selectAppDomain);
    const { canApprovePaymentLinks, showApprovePaymentLinks } = useInstructionsPermissioning();
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags, error: featureFlagError } = useFeatureFlag();
    const isNfseStandaloneEnabled = !isLoadingFeatureFlags &&
        !featureFlagError &&
        isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE_STANDALONE);
    const hasAccountPjPermission = useRequiresAuthorization(hasAccountPjParams.domain, hasAccountPjParams.resources, undefined, undefined, ResourceBehavior.OR);
    const hasDigitalAccountingPermission = useRequiresAuthorization(hasDigitalAccountingParams.domain, hasDigitalAccountingParams.resources, undefined, undefined, ResourceBehavior.OR);
    const hasBenefitPermission = useRequiresAuthorization(hasBenefitParams.domain, hasBenefitParams.resources, undefined, undefined, ResourceBehavior.OR);
    const programaFidelidadeFromAuth = useRequiresAuthorization(hasProgramaFidelidadeParams.domain, hasProgramaFidelidadeParams.resources, undefined, appDomain !== AppDomain.ESCRITORIO, ResourceBehavior.OR);
    const hasProgramaFidelidadePermission = appDomain === AppDomain.ESCRITORIO ? programaFidelidadeFromAuth : false;
    const validBillingPermission = useRequiresAuthorization(hasBillingParams.domain, hasBillingParams.resources, undefined, undefined, ResourceBehavior.OR);
    const hasBillingPermission = validBillingPermission;
    const hasClientPortalViewPermission = useRequiresAuthorization(hasClientPortalParams.domain, hasClientPortalParams.resources, undefined, undefined, ResourceBehavior.OR);
    const validNfsePermission = useRequiresAuthorization(hasNfseParams.domain, hasNfseParams.resources, undefined, !isNfseStandaloneEnabled, ResourceBehavior.OR);
    const hasNfsePermission = isNfseStandaloneEnabled ? validNfsePermission : false;
    const filteredPermissionsAmount = [
        hasAccountPjPermission,
        hasDigitalAccountingPermission,
        hasBenefitPermission,
        hasBillingPermission,
        hasNfsePermission,
    ];
    const finishedValidations = filteredPermissionsAmount.every(permission => permission !== undefined);
    return {
        hasAccountPjPermission,
        hasDigitalAccountingPermission,
        hasBillingPermission,
        hasBenefitPermission,
        hasProgramaFidelidadePermission,
        hasClientPortalViewPermission,
        hasNfsePermission,
        finishedValidations,
        canApprovePaymentLinks,
        showApprovePaymentLinks,
    };
};
